import { render, staticRenderFns } from "./AppointmentsRelocationView.vue?vue&type=template&id=919f40f8&scoped=true&lang=pug"
import script from "./AppointmentsRelocationView.vue?vue&type=script&lang=js"
export * from "./AppointmentsRelocationView.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsRelocationView.vue?vue&type=style&index=0&id=919f40f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919f40f8",
  null
  
)

export default component.exports